import { Pipe, type PipeTransform } from '@angular/core';
import { PhonebookCustomDto } from './../shared/phonebook-custom.model';

@Pipe({
  name: 'removeEmptyContacts',
  standalone: true,
})
export class RemoveEmptyContactsPipe implements PipeTransform {
  transform(phonebooks: PhonebookCustomDto[]): PhonebookCustomDto[] {
    return phonebooks?.filter((r) => r?.contactsCount);
  }
}
